import { render, staticRenderFns } from "./modelPlaceUI.vue?vue&type=template&id=175b232d&scoped=true"
import script from "./modelPlaceUI.vue?vue&type=script&lang=js"
export * from "./modelPlaceUI.vue?vue&type=script&lang=js"
import style0 from "./modelPlaceUI.vue?vue&type=style&index=0&id=175b232d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175b232d",
  null
  
)

export default component.exports